import { RecommendationType } from '../types/RecommendationType';
import { FilterParams } from '../types/types';

type BrandClubPowerstepParam =
    | FilterParams<'recommendation_type', RecommendationType>
    | FilterParams<'product_type'>
    | FilterParams<'level'>
    | FilterParams<'position'>;

export default function getBrandClubPowerstepParams(label): BrandClubPowerstepParam[] {
    const paramValues = label.split('_');
    const levelAndPositionParamValues = paramValues[2].split(' - ');

    return [
        { param_name: 'recommendation_type', param_value: 'brand_club_powerstep' },
        { param_name: 'product_type', param_value: paramValues[1] },
        { param_name: 'level', param_value: levelAndPositionParamValues[0] },
        { param_name: 'position', param_value: levelAndPositionParamValues[1] }
    ];
}
